module.exports = __webpack_public_path__ + "static/img/5.79b4973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/5.jpg
// module id = b2ki
// module chunks = 1